import { render } from "./OurMission.vue?vue&type=template&id=71a290fd&ts=true"
import script from "./OurMission.vue?vue&type=script&lang=ts"
export * from "./OurMission.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__